const styles = theme => ({
  textField: {
    width: '100%',
    maxWidth: 450
  }
})

export default styles
